<template>
	<div class="main">
		<!-- <div class="main"></div> -->
		<!-- <div id="content"> -->
		<div class="cont">
			<div class="banner">
				<!-- <img src="../assets/images/topicalimg.png" alt=""> -->
			</div>
			<div class="bg"><!-- <img src="../assets/images/bg2.jpg" alt=""> --></div>
			<!-- <div class="poster" @click.prevent="showPoster"><img src="../assets/images/share.png" alt=""></div> -->
			<div class="nav">
				<ul>
					<li @click="goAnchor('#active')"><img src="../assets/images/li2_1.png" alt=""></li>
					<li @click="goAnchor('.video')"><img src="../assets/images/li2_2.png" alt=""></li>
					<li @click="goAnchor('.news')"><img src="../assets/images/li2_3.png" alt=""></li>
					<li @click="goAnchor('.people')"><img src="../assets/images/li2_4.png" alt=""></li>
					<li @click="goAnchor('.pic')"><img src="../assets/images/li2_5.png" alt=""></li>
					<li @click="goAnchor('.form')"><img src="../assets/images/li2_6.png" alt=""></li>
				</ul>
			</div>
			<!--<div class="desc"> <img src="../assets/images/desc.png" alt=""> </div>-->

			<div class="active" id="active">
				<!-- <carousel-3d class="slider" :width="sliderWidth" :height="sliderHeight" :disable3d="false"
						:autoplay="autoplay" :display="1"  :controls-visible="true" :loop="loop">
						<slide v-for="(slide, i) in yitijujiaoData" :index="i" :key="i" class="item" >
							<template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
								<a :href="slide.href">
									<img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="slide.imgurl">
									<div class="title">{{slide.title}}</div>
								</a>
							</template>
						</slide>
					</carousel-3d> -->
					<!-- 议题聚焦 -->
				<carousel-3d class="slider" ref="attrRef"  :width="yiti_sliderWidth" :height="yiti_sliderHeight" :autoplay="autoplay"
					:display="yiti_sliderDisplay" :controlsVisible="yiti_controlsVisible" :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'" :controls-visible="sliderControls" :loop="loop" :oneDirectional="yiti_oneDirectional">
					<slide v-for="(slide, i) in yitijujiaoData" :index="i" :key="i">
						<template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
							<a :href="slide.href" target="_blank">
								<img class="acimg" :data-index="index"
									:class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
									:src="slide.imgurl">
								<div  class="actitle">{{slide.title}}</div>
							</a>

						</template>
					</slide>
				</carousel-3d>
				<!-- <div class="tips"><img src="../assets/images/tips.png" alt=""></div> -->
				<!-- <slider ref="slider" :options="options" > 
						slideritem wrapped package with the components you need
						<template slot-scope="coverflow">
							<slideritem class="item" v-for="(item,index) in yitijujiaoData"  :index="index" :key="index">
								<a :href="item.href">
									<img :src="item.imgurl" alt="">
									<div class="title">{{item.title}}</div>
								</a> 
							</slideritem>
						</template>
					</slider>
					<div class="next" @click="slideNext"><img src="../assets/images/slid_next.png" alt=""></div>
					<div class="pre" @click="slide"><img src="../assets/images/slid_pre.png" alt=""></div> -->
			</div>

			<div class="part video">
				<!-- <slider ref="slider" :options="options"> -->
				<!-- slideritem wrapped package with the components you need -->
				<!-- <template slot-scope="coverflow">
							<slideritem class="item" v-for="(item,index) in videoData"  :index="index" :key="index"> -->
				<video @play="videoIsPlayInit = true;" @pause="videoIsPlayInit = false;"
					@ended="videoIsPlayInit = false;" ref="playerRef" id="videoPlayer" :src="videoData[0].video_url"
					:poster="videoData[0].video_img" class="my-video" style="width:100%;" controls preload="none"
					autobuffer="" x5-playsinline="" playsinline="" webkit-playsinline="" x-webkit-airplay="true">
				</video>
				<i class="start-play" v-show="!videoIsPlayInit" @click="changeVideoStatus('init')"></i>
				<div class="title">{{videoData[0].title}}</div>
				<!-- <div class="more" v-show="videoData.length>1" @click="MoreVideo"><img src="../assets/images/more.png"
						alt=""></div> -->
				<div class="pre-btn" v-show="videoPageIndex != 1" @click="getVideo('pre')"><img
						src="../assets/images/pre.png" alt=""></div>
				<div class="next-btn" v-show="videoPageIndex != videoAllPage" @click="getVideo('next')"><img
						src="../assets/images/next.png" alt=""></div>
				<!-- </slideritem>
						</template> -->
				<!-- </slider> -->
			</div>

			<div class="part news">
				<ul>
					<li v-for="(item,index) in newsListData" :index="index" :key="index">
						<div class="disc"></div>
						<div class="news-title"><a :href="item.href">{{item.title}}</a></div>
					</li>
				</ul>
				<div class="pre-btn" v-show="newsPageIndex != 1" @click="getNews('pre')"><img
						src="../assets/images/pre.png" alt=""></div>
				<div class="next-btn" v-show="newsPageIndex != newsAllPage" @click="getNews('next')"><img
						src="../assets/images/next.png" alt=""></div>
			</div>

			<div class="part people">
				<div class="title">
					<!-- <img src="../assets/images/peo.png" alt=""> -->
				</div>
				<ul>
					<li v-for="(item,index) in peopleData" :index="index" :key="index" @click="showPoup(item)">
						<div class="head"><img :src="item.headimg" alt=""></div>
						<div class="name">{{item.name}}</div>
					</li>
				</ul>

			</div>

			<div class="part pic">
				<carousel-3d class="slider" :width="sliderWidth" :height="sliderHeight" :autoplay="autoplay"
					:display="sliderDisplay" :controlsVisible="controlsVisible"  :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'" :controls-visible="sliderControls" :loop="loop">
					<slide v-for="(slide, i) in picData" :index="i" :key="i">
						<template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
							<a :href="slide.href">
								<img :data-index="index"
									:class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
									:src="slide.imgurl">
							</a>

						</template>
					</slide>
				</carousel-3d>
				<div class="tips"><img src="../assets/images/tips.png" alt=""></div>
			</div>

			<div class="part form ">
				<!-- <img src="../assets/images/infor.png" alt=""> -->
				<div class="name"><input type="text" v-model="form.name" placeholder=" 姓  名 "></div>
				<div class="tel"><input type="text" v-model="form.phone" placeholder="手机号码"></div>
				<div class="opinion"><textarea type="text" v-model="form.opinion" placeholder="倾听您的意见"></textarea></div>
				<div class="submit" @click.prevent="submit(0)"></div>
			</div>

			<div class="part logo" v-if="juZhengData.length>0">
				<div class="title"><!-- <img src="../assets/images/logo2.png" alt=""> --></div>
				<ul>
					<li v-for="(item,index) in juZhengData" :index="index" :key="index">
						<div class="head"><img :src="item.headimg" alt=""></div>
						<div class="name">
							{{item.nickname}}
							<div class="text">{{item.href}}</div>
						</div>

					</li>
				</ul>

			</div>

			<div class="slide-nav" @click="goAnchor('.form')">
				<img src="../assets/images/gototext.png" alt="">
			</div>


		</div>
		<!-- </div> -->
		<!-- 视频播放 -->
		<popup v-model="currentValue" class="videoBox">
			<div class="bg">
				<div class="close" @click="popupClose"><img src="../assets/images/close.png" alt=""></div>
				<div class="contet">
					<div class="videoList" v-for="(item,index) in videoData" :index="index" :key="index"
						v-show="index!=0">

						<video @play="videoIsPlay.splice(index,1,true)" @pause="videoIsPlay.splice(index,1,false);"
							@ended="videoIsPlay.splice(index,1,false);" :ref="'playerRef_'+index" :src="item.video_url"
							:poster="item.video_img" class="my-video" style="width:100%;" controls preload="none"
							autobuffer="" x5-playsinline="" playsinline="" webkit-playsinline=""
							x-webkit-airplay="true">
						</video>
						<i class="start-play" v-show="!videoIsPlay[index]" @click="changeVideoStatus(index)"></i>
						<div class="title">{{item.title}}</div>
					</div>
				</div>
			</div>
		</popup>
		
		<popup v-model="isShowPeo" class="peo">
			<div class="infor">
				<div class="close" @click="popupClose"><img src="../assets/images/close.png" alt=""></div>
				<div class="userinfo">
					<div class="head"><img :src="this.peoDetai.headimg" alt=""></div>
					<div class="name">{{this.peoDetai.name}}</div>
					<div class="zw">{{this.peoDetai.position}}</div>
					<div class="brif" v-html="this.peoDetai.personnel_desc"></div>
					<div class="tips" v-show="peoDetai.ishas">您的建议正在受理中，请耐心等待受理结果。</div>
				</div>
				<div class="userform">
					<div class="tel"><input type="text" v-model="form.phone" placeholder="手机号码"></div>
					<div class="opinion"><textarea type="text" v-model="form.opinion" placeholder="倾听您的意见"></textarea></div>
					<div class="submit" @click.prevent="submit(1)"></div>
					
				</div>
			</div>
		</popup>
		
		<popup v-model="isYiti" class="yitiBox">
			<div class="infor">
				<div class="close" @click="popupClose"><img src="../assets/images/close.png" alt=""></div>
				<div class="contet">
					
				</div>
			</div>
		</popup>

		<popup v-model="isPoster" class="posterBox">
			<div class="posterContent" ref="poster">
				<div class="posterImag"><img src="../assets/images/banner.jpg" alt=""></div>
				<vue-qr class="qrcode" :text="themUrl" :size="150" :margin="0" colorDark="black" colorLight="white">
				</vue-qr>
				<div class="text">{{tips}}</div>
				<div class="posterUrl"><img :src="posterUrl" alt=""></div>
			</div>
			<div class="close" @click="popupClose"><img src="../assets/images/close.png" alt=""></div>
		</popup>
	</div>
</template>

<script>
	import axios from 'axios';
	import $ from 'jquery';
	import swal from "sweetalert";
	import {
		Carousel3d,
		Slide
	} from 'vue-carousel-3d';
	import {
		slider,
		slideritem
	} from 'vue-concise-slider'
	import Qs from "qs";
	import popup from "../components/Popup.vue";

	import vueQr from "vue-qr";
	import html2canvas from "html2canvas"
	// import getJpeg from '@/utils/htmlJpeg'


	export default {
		name: 'Main',

		components: {
			Carousel3d,
			Slide,
			slider,
			slideritem,
			popup,
			vueQr,
			html2canvas,
		},

		data() {
			return {
				themUrl: '',
				isPoster: false,
				
				isYiti:false,
				
				yitijujiaoData: [],

				currentValue: false,
				isShowPeo: false,
				
				controlsVisible:true,
				sliderDisplay: 3,
				sliderWidth: 0,
				sliderHeight: 0,
				sliderControls: false,
				
				yiti_controlsVisible:true,
				yiti_sliderDisplay: 3,
				yiti_sliderWidth:0,
				yiti_sliderHeight:0,
				yiti_oneDirectional: false,
				
				autoplay: true,
				loop: true,

				newsListData: [],
				newsTotal: 0,
				newsAllPage: 1,
				newsPageIndex: 1,
				
				videoListData: [],
				videoTotal: 0,
				videoAllPage: 1,
				videoPageIndex: 1,

				videoIsPlayInit: false,
				videoData: [],
				videoIsPlay: [],
				currentVideoplay: '',
				options: {
					//   currentPage: 0,//当前页码
					//   thresholdDistance: 500,//滑动判定距离
					//   thresholdTime: 100,//滑动判定时间
					autoplay: 3000, //自动滚动[ms]
					loop: true, //循环滚动
					// //   direction:'vertical',//方向设置，垂直滚动
					//   loopedSlides:1,//无限滚动前后遍历数
					//   slidesToScroll:1,//每次滑动项数
					//   timingFunction: 'ease', // 滑动方式
					//   speed: 300, // 滑动时间
					//   pagination: false,
					thresholdDistance: 100, // Sliding distance threshold
					thresholdTime: 300, // Sliding time threshold decision
					grabCursor: true, // Scratch style
					speed: 300 // Sliding speed
				},

				peopleData: [],
				peoDetai: {
					ishas: false
				},

				picData: [],

				form: {
					name: '',
					phone: '',
					opinion: '',
					wid: 0,
				},
				tips: '扫一扫，建言献策',
				posterUrl: '',
				juZhengData: [],

			};
		},
		created() {
			this.yiti_sliderWidth = 480
			console.log(this.yiti_sliderWidth)
			this.getData();
		},

		mounted() {
			var is_mobi = navigator.userAgent.toLowerCase().match(
					/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) !=
				null;
			if (is_mobi) {
				this.sliderWidth = 240
				this.sliderHeight = 135
				this.sliderDisplay = 3
				// this.sliderControls = false
				this.yiti_sliderWidth = 0
				this.yiti_sliderHeight= 0
				window.location.href="https://fj.sina.cn/zt/lulitongxin";
			} else {
				
				
				this.sliderWidth = 320
				this.sliderHeight = 320* (506/898)
				this.sliderDisplay = 3
				// this.sliderControls = false
				console.log(11111111112)
				//console.log(document.body.clientWidth)
				//alert( document.getElementsByClassName("active").clientWidth)
				// 获取元素宽高//报错
				    /* const w = this.$refs.attrRef.offsetWidth
				    const h = this.$refs.attrRef.offsetHeight
				    console.log('获取元素宽高', w, h) */
					//console.log(documentWidth)
				this.yiti_sliderWidth = 310
				this.yiti_sliderHeight= 310* (621/1110)
			}
			this.themUrl = location.origin + location.pathname

		},

		methods: {
			changeVideoStatus(index) {
				this.$nextTick(() => {
					if (index == "init") {
						if (this.$refs.playerRef.paused) {
							this.$refs.playerRef.play();
						} else {
							this.$refs.playerRef.pause();
						}
						return false
					}
					if (this.currentVideoplay) {
						let i = parseInt(this.currentVideoplay.split("_")[1])
						if (i == index) {
							console.log(this.$refs[this.currentVideoplay])
							if (this.$refs[this.currentVideoplay][0].paused) {
								this.$refs[this.currentVideoplay][0].play();
								this.videoIsPlay.splice(index, 1, true)
							} else {
								this.$refs[this.currentVideoplay][0].pause();
								this.videoIsPlay.splice(index, 1, false)
							}
						} else {
							this.$refs[this.currentVideoplay][0].pause()
							this.videoIsPlay.splice(i, 1, false)
							this.currentVideoplay = `playerRef_${index}`
							this.$refs[this.currentVideoplay][0].play();
							this.videoIsPlay.splice(parseInt(index), 1, true)
						}
					} else {
						this.currentVideoplay = `playerRef_${index}`
						console.log(this.$refs[this.currentVideoplay])
						this.$refs[this.currentVideoplay][0].play();
						this.videoIsPlay.splice(index, 1, true)
					}
				})


			},
			videoPlay(index) {
				if (this.currentVideoplay) {
					let i = this.currentVideoplay.split("_")[1]
					if (i == index) {
						if (this.$refs[this.currentVideoplay].paused) {
							this.$refs[this.currentVideoplay].play();
						} else {
							this.$refs[this.currentVideoplay].pause();
						}
					} else {
						this.$refs[this.currentVideoplay].paused()
						this.currentVideoplay = `playerRef_${index}`
						this.$refs[this.currentVideoplay].play();
					}
				}
			},
			goAnchor(selector) {
				/*参数selector是id选择器（#anchor14）*/
				this.$nextTick(() => {
					document.querySelector(selector).scrollIntoView({
						behavior: "smooth"
					});
				})
			},
			getData() {
				let data = {};
				axios.post("https://www.appmn.cn/project2022/huijululi/index_pc_json.php", data)
					.then(response => {
						let json = response.data;
						if (json.err == 0) {
							if (json.data.zhengxiedongtai_list && json.data.zhengxiedongtai_list.length > 0) {
								this.newsListData = json.data.zhengxiedongtai_list;
								this.newsAllPage = json.data.zhengxiedongta_list_allpage;
							}
							if (json.data.ludaoyishiting_list && json.data.ludaoyishiting_list.length > 0) {
								this.videoData = json.data.ludaoyishiting_list;
								this.videoAllPage = json.data.ludaoyishiting_list_allpage;
								this.videoData.map((item, index) => {
									this.videoIsPlay.push(false)
								})
							}
							if (json.data.weiyuanfengcai_list && json.data.weiyuanfengcai_list.length > 0) {
								this.peopleData = json.data.weiyuanfengcai_list;
							}
							if (json.data.yitijujiao_list && json.data.yitijujiao_list.length > 0) {
								this.yitijujiaoData = json.data.yitijujiao_list;
							}
							if (json.data.huodonglveying_list && json.data.huodonglveying_list.length > 0) {
								this.picData = json.data.huodonglveying_list;
							}
							if (json.data.juzhenzhanghao_list && json.data.juzhenzhanghao_list.length > 0) {
								this.juZhengData = json.data.juzhenzhanghao_list;
							}

						} else {
							swal(json.msg)
						}
					})
			},
			getVideo(page){
				if (page == "pre") {
					this.videoPageIndex == 1 ? this.videoPageIndex : this.videoPageIndex--
				} else {
					this.videoPageIndex == this.videoAllPage ? this.videoPageIndex : this.videoPageIndex++
				}
				let data = {
					p: this.videoPageIndex
				};
				
				axios.post("https://www.appmn.cn/project2022/huijululi/ludaoyishiting.php", Qs.stringify(data))
				.then(response => {
					let json = response.data;
					if (json.err == 0) {
						if (json.data.ludaoyishiting_list && json.data.ludaoyishiting_list.length > 0) {
							this.videoData = json.data.ludaoyishiting_list;
							console.log(this.videoData)
						}
					} else {
						swal(json.msg)
					}
				})
			},
			getNews(page) {
				if (page == "pre") {
					this.newsPageIndex == 1 ? this.newsPageIndex : this.newsPageIndex--
				} else {
					this.newsPageIndex == this.newsAllPage ? this.newsPageIndex : this.newsPageIndex++
				}
				console.log(this.newsPageIndex)
				let data = {
					p: this.newsPageIndex
				};
				axios.post("https://www.appmn.cn/project2022/huijululi/zhengxiedongtai_pc.php", Qs.stringify(data))
					.then(response => {
						let json = response.data;
						if (json.err == 0) {
							if (json.data.zhengxiedongtai_list && json.data.zhengxiedongtai_list.length > 0) {
								this.newsListData = json.data.zhengxiedongtai_list;
								console.log(this.newsListData)
							}
						} else {
							swal(json.msg)
						}
					})
			},
			slideNext() {
				this.$refs.slider.$emit('slideNext')
			},
			slide() {
				this.$refs.slider.$emit('slidePre')
			},
			showPoup(item) {
				this.form = {
					opinion: '',
					phone: '',
					name: ''
				}
				// this.peoDetai = { ...this.peoDetai,...{ishas: false}}
				this.peoDetai = {
					...item,
					...{
						ishas: false
					}
				}
				this.$refs[`playerRef`].pause()
				let data = {}
				data.token_code = localStorage.getItem('token')
				data.wid = item.id
				this.isShowPeo = true
				axios.post("https://www.appmn.cn/project2022/huijululi/weiyuanfengcai_issubed.php", Qs.stringify(data))
					.then(response => {
						let json = response.data;
						if (json.err == 0) {
							this.peoDetai = {
								...this.peoDetai,
								...{
									ishas: json.data.ishas ? true : false
								}
							}
							// this.$set(this.peoDetai,"ishas",json.data.ishas ? true: false)
						} else {
							swal(json.msg)
						}
					})

			},
			showPoster() {
				this.$refs[`playerRef`].pause()
				this.isPoster = true
				let width = document.documentElement.clientWidth;
				let height = document.documentElement.clientHeight;
				this.$nextTick(() => {
					const ref = this.$refs.poster // 截图区域
					height = this.$refs.poster.offsetHeight; // 获取(原生）dom 高
					width = this.$refs.poster.offsetWidth; // 获取(原生）dom 高
					var offsetTop = ref.offsetTop; //元素距离顶部的偏移量
					var canvas = document.createElement('canvas'); //创建canvas 对象
					var context = canvas.getContext('2d');
					// 【重要】关闭抗锯齿
					context.mozImageSmoothingEnabled = false;
					context.webkitImageSmoothingEnabled = false;
					context.msImageSmoothingEnabled = false;
					context.imageSmoothingEnabled = false;

					var scaleBy = this.getPixelRatio(context); //获取像素密度的方法 (也可以采用自定义缩放比例)
					canvas.width = width * scaleBy; //这里 由于绘制的dom 为固定宽度，居中，所以没有偏移
					canvas.height = (height + offsetTop) * scaleBy;

					var opts = {
						allowTaint: true, //允许加载跨域的图片
						tainttest: true, //检测每张图片都已经加载完成
						scale: scaleBy, // 添加的scale 参数
						canvas: canvas, //自定义 canvas
						logging: false, //日志开关，发布的时候记得改成false
						width: width, //dom 原始宽度
						height: height, //dom 原始高度
						useCORS: true, //开启跨域配置
					};
					html2canvas(ref, opts).then((canvas) => {
						this.posterUrl = canvas.toDataURL('image/png')
						this.tips = '长按保存图片'
					})
				})

			},
			popupClose() {
				this.isShowPeo = false
				this.isPoster = false
				this.currentValue = false
				this.tips = '扫一扫，建言献策'
				if (this.currentVideoplay) {
					this.$refs[this.currentVideoplay][0].pause()
					this.currentVideoplay = '';
				}
				// this.form.opinion = ""
				// this.form.phone =""
				// this.form.name=""
				// this.form.wid=0
				this.form = {
					opinion: '',
					phone: '',
					name: '',
					wid: 0
				}
			},
			getPixelRatio(context) {
				var backingStore = context.backingStorePixelRatio ||
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio || 1;
				return (window.devicePixelRatio || 1) / backingStore;
			},
			submit(isPeo = 0) {
				console.log(isPeo)
				if (!isPeo) {
					if (this.form.name == "") {
						swal("请填写姓名")
						return
					}
					this.form.wid = 0
				} else {
					this.form.name = this.$parent.projectInfor.nickname
					this.form.wid = this.peoDetai.id
				}

				if (this.form.phone == "") {
					//swal("请填写手机号码")
					//return
				}
				if (this.form.opinion == "") {
					swal("请填写您的意见")
					return
				}
				if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.form
					.phone)) {
					//swal("手机号码有误")
					//return
				}
				let data = {
					...this.form
				}
				data.token_code = localStorage.getItem('token')
				axios.post("https://www.appmn.cn/project2022/huijululi/shequminyi.php", Qs.stringify(data))
					.then(response => {
						let json = response.data;
						if (json.err == 0) {
							swal(json.msg)
							// this.form.opinion = ""
							// this.form.phone =""
							// this.form.name=""
							this.form = {
								...this.form,
								...{
									opinion: '',
									phone: '',
									name: ''
								}
							}
							this.peoDetai = {
								...this.peoDetai,
								...{
									ishas: true
								}
							}
						} else {
							swal(json.msg)
						}
					})
			},
			MoreVideo() {
				this.$refs[`playerRef`].pause()
				this.currentValue = true
				// this.stopMove()
			}
		},
	};
</script>

<style lang="scss" scoped>
	@import url("../assets/css/index.css");

	// @import url("../assets/css/box.css");
	.slide-nav {
		position: fixed;
		bottom: .5rem;
		right: 0;
		width: 1.49rem;
		z-index: 9;
	}
   
	
		
	.poster {
		width: .72rem;
		right: .5rem;
		top: 0.5rem;
		position: absolute;
	}

	.nav {
		// margin-top: 10.16rem;
		position: relative;
		margin: 1rem auto 0;
		width: 12rem;
	
	ul {
			display: flex;
			justify-content: space-around;
			align-content: center;

			li {
				width: 1.9rem;
			}
		}
	}

	.desc {
		margin: .55rem auto 0;
		position: relative;
		width: 12rem;
		height: calc(12rem * (183/615));
		background: url(../assets/images/desc.png);
		background-size: 100% 100%;
	}
	.carousel-3d-container div.carousel-3d-slider{
		/* width: 12rem;
		height: calc(12rem * (730/1400)); */
	}
	.active {
		position: relative;
		margin: .85rem auto 0;
		width: 12rem;
		height: calc(12rem * (730/1400));
		background: url(../assets/images/active_bg2.png);
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 1.5rem .8rem .2rem .8rem;
		
		::v-deep .prev{
				    color: #06599f !important;
					left: -50px;
		}
		::v-deep .next{
				    color: #06599f !important;
					right: -50px;
		}
		.carousel-3d-container{
			
				width: 9rem !important;
				height: calc(9rem * (387/1105)) !important;
				overflow:unset !important;
				/* position: relative !important; */
				
				::v-deep .carousel-3d-slider{
					width: 9rem !important;
					height: calc(9rem * (387/1105)) !important;
					display: flex;
					justify-content: center;
				}
				
		}
		
		.carousel-3d-slide.current{
			width: 5.6rem !important;
			height: calc(6.6rem * (621/1110)) !important;
			.actitle{
				    font-size: 0.24rem;
				    bottom: 0;
				    left: 0;
				    position: absolute;
				    display: inline-block;
				    width: 100%;
					color: #ffffff;
			}
		}
		.carousel-3d-slide{
			width: 5.6rem !important;
			height: calc(5.6rem * (621/1110)) !important;
			background-color: transparent;
			border-color: transparent;
			text-align: center;
			color: #ffffff;
		}
		.acimg{
			width: 5.6rem !important;
			height: calc(5.6rem * (621/1110)) !important;
		}
		
		
		
		.slider-container {

			.item,
			.item a {
				width: 100%;
				height: 100%;
			}

			.title {
				font-size: .24rem;
				color: #fff;
				margin-top: .4rem;
				text-align: center;
			}
			
			
		}
	
	.next {
			position: absolute;
			width: 0.26rem;
			height: 0.71rem;
			right: 0.3rem;
			top: 50%;
		}

		.pre {
			position: absolute;
			width: 0.26rem;
			height: 0.71rem;
			left: 0.3rem;
			top: 50%;
		}
	}

	.video {
		position: relative;
		margin: .55rem auto 0;
		width: 12rem;
		height: calc(12rem * (1026/1400));
		background: url(../assets/images/video_bg2.png);
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 1.7rem 0 0 1.2rem;

		video {
			position: relative;
			width: 9.5rem !important;
			// margin: 1.45rem auto 0;
		}

		.title {
			position: relative;
			    width: 7.4rem;
			    color: #fff;
			    left: 1.2rem;
			    font-size: 0.24rem;
			    text-align: center;
			    margin-top: -0.15rem;
		}

		.more {
			position: absolute;
			bottom: 0.9rem;
			right: 1rem;
			width: 1.52rem;

			img {
				vertical-align: bottom;
			}

		}

		.start-play {
			cursor: pointer;
			width: 1.5rem;
			height: 1.5rem;
			background: linear-gradient(135deg, #909193 0%, #282828 100%);
			opacity: 1;
			border-radius: 50%;
			display: block;
			position: absolute;
			margin: auto;
			top: 3.6rem;
			left: 50%;
			transform: translate(-50%, 0);

			&::after {
				content: "";
				width: 0;
				height: 0;
				border: 0.26rem solid transparent;
				border-left: 0.38rem solid white;
				position: absolute;
				top: 32%;
				left: 40%;
			}
		}
		
		
		.pre-btn {
			width: 1.93rem;
			position: absolute;
			bottom: 0.85rem;
			left: 1.2rem;
			display: inline-block;
		
			img {
				vertical-align: bottom;
			}
		}
		
		.next-btn {
			width: 1.75rem;
			position: absolute;
			bottom: 0.85rem;
			right: 1.2rem;
		
			img {
				vertical-align: bottom;
			}
		}

	}

	.news {
		position: relative;
		margin: .55rem auto 0;
		width: 12rem;
		height: calc(12rem * (1014/1400));
		background: url(../assets/images/news_bg2.png);
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 1.7rem .5rem 0 .5rem;
		overflow: hidden;
		display: flex;
		align-items: center;

		ul {
			width: 10rem;
			height: 6rem;
			position: relative;
			margin: 0 auto;

			// display: flex;
			// flex-direction: column;
			// justify-content: center;
			// list-style: disc;
			li {
				color: #fff;
				font-size: .28rem;
				// list-style: disc;
				// list-style-position:inside;
				margin: 0.08rem 0.38rem;
				width: 4rem;
				float: left;
				padding: 0.08rem;
				border-block-end: #0c3686 dashed .05rem;
				display: list-item;
				position: relative;

				.disc {
					color: #fff;
					background: #fff;
					width: 0.1rem;
					height: 0.1rem;
					border-radius: 50%;
					// display: inline-block;
					position: absolute;
					left: -.2rem;
					top: .2rem
				}

				// .disc{
				// 	display: inline-block;
				// 	width: .15rem;
				// 	height: .15rem;
				// 	background: #fff;
				// 	border-radius: 50%;
				// 	margin-right: 0.1rem;
				// }
				// .news-title{
				// 	display: inline-block;
				// 	width: 95%;
				// }
				.news-title a {
					color: #fff;
					display: inline-block;
					overflow: hidden;
					-webkit-line-clamp: 2;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					// line-height: .35rem;
					line-height: 0.38rem;
					font-size: .26rem;
					letter-spacing: .02rem;
				}
			}
		}

		.pre-btn {
			width: 1.93rem;
			position: absolute;
			bottom: 1rem;
			left: 1.2rem;
			display: inline-block;

			img {
				vertical-align: bottom;
			}
		}

		.next-btn {
			width: 1.75rem;
			position: absolute;
			bottom: 1rem;
			right: 1.2rem;

			img {
				vertical-align: bottom;
			}
		}
	}

	.people {
		position: relative;
		margin: .55rem auto 0;
		width: 12rem;

		.title {
			position: relative;
			margin: 0 auto;
			width: 12rem;
			height: calc(12rem * (158/1400));
			background: url(../assets/images/peo2.png);
			background-size: 100% 100%;
		}

		ul {
			display: flex;
			justify-content: flex-start;
			width: 11rem;
			margin: 0.4rem 0.8rem;
			flex-wrap: wrap;

			li {
				width: 2.3rem;
				margin: 0.3rem 0.2rem;
				display: flex;
				flex-direction: column;
				align-items: center;

				.head {
					width: 2.1rem;
					height: 2.1rem;
					background: url(../assets/images/head.png);
					background-size: 100% 100%;
					box-sizing: border-box;
					padding: 0.15rem;

					img {
						border-radius: 50%;
						overflow: hidden;
						width: 100%;
						height: 100%;
					}
				}

				.name {
					position: relative;
					text-align: center;
					width: 1.75rem;
					color: #fff;
					font-size: .24rem;
					margin: 0.15rem 0 0 0;
				}

			}
		}

	}

	.pic {
		position: relative;
		margin: .55rem auto 0;
		width: 12rem;
		height: calc(12rem * (817/1400));
		background: url(../assets/images/pic_bg2.png);
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 1.5rem .25rem 0 .25rem;
	
	.carousel-3d-container {
			margin: 0.5rem auto;
		}
		
		::v-deep .prev{
				    color: #06599f !important;
					left: -50px;
		}
		::v-deep .next{
				    color: #06599f !important;
					right: -50px;
		}
		.carousel-3d-container{
			
				width: 9rem !important;
				height: calc(9rem * (387/1105)) !important;
				overflow:unset !important;
				/* position: relative !important; */
				
				::v-deep .carousel-3d-slider{
					width: 9rem !important;
					height: calc(9rem * (387/1105)) !important;
					display: flex;
					justify-content: center;
				}
				
		}
		
		.carousel-3d-slide.current{
			width: 5.6rem !important;
			height: calc(5.6rem * (621/1110)) !important;
			.actitle{
				    font-size: 0.24rem;
				    bottom: 0;
				    left: 0;
				    position: absolute;
				    display: inline-block;
				    width: 100%;
			}
		}
		.carousel-3d-slide{
			width: 5.6rem !important;
			height: calc(5.6rem * (621/1110)) !important;
			background-color: transparent;
			border-color: transparent;
			text-align: center;
			color: #ffffff;
		}
		.acimg{
			width: 5.6rem !important;
			height: calc(5.6rem * (621/1110)) !important;
		}

		.tips {
			position: relative;
			margin: 0.8rem auto;
			width: 4.93rem;
		}
	}

	.form {
		position: relative;
		margin: 1.2rem auto 0;
		width: 12rem;
		height: calc(12rem * (1027/1400));
		background: url(../assets/images/infor2.png?v=1);
		background-size: 100% 100%;
		box-sizing: border-box;
		font-size: .24rem;
		bottom: 0.3rem;

		.name {
			position: absolute;
			top: 3.1rem;
			left: 0.9rem;
			width: 5rem;
			height: 0.7rem;
		}

		.tel {
			position: absolute;
			top: 3.1rem;
			left: 6.2rem;
			width: 5rem;
			height: 0.7rem;
		}

		.opinion {
			position: absolute;
			top: 4.2rem;
			left: 1rem;
			width: 10.1rem;
			height: 2.7rem;
		}

		.submit {
			position: absolute;
			top: 7.5rem;
			left: 50%;
			width: 2.5rem;
			height: 0.7rem;
			margin-left: 2.65rem;
		}

		input,
		textarea {
			width: 100%;
			height: 100%;
			background: none;
			border: none;
			text-indent: .2rem;
		}
	}
	.yitiBox{
		position: relative;
		margin: 0 auto;
		width: 6rem;
		
		.infor {
			position: relative;
			width:10rem;
			height: calc(10rem * (1051/1345));
			background: url(../assets/images/box2.png);
			background-size: 100% 100%;
			box-sizing: border-box;
			padding: 0.9rem .5rem;
		
			.close {
				position: absolute;
				    top: 1.3rem;
				    right: 1rem;
				    width: 1.3rem;
				    opacity: 1;
					cursor: pointer;
		
			}
		}
	}
	.posterBox {
		position: relative;
		margin: 0 auto;
		width: 6rem;

		.close {
			position: absolute;
			top: 0.7rem;
			right: 1rem;
			width: 0.82rem;
			opacity: 1;
		}

		.posterContent {
			position: relative;
			margin: 0 auto;
			width: 6rem;
		}

		.qrcode {
			position: absolute;
			bottom: 2rem;
			left: .5rem;
			/* margin-left: -0.6rem; */
			width: 1.2rem;
		}

		.text {
			position: absolute;
			bottom: 1.6rem;
			font-size: .14rem;
			color: #fff;
			width: 5rem;
			text-align: center;
			margin-left: -1.4rem;
		}

		.posterUrl {
			width: 100%;
			height: 100%;
			opacity: 0;
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	.peo {
		::v-deep .popupBox{
			left: 50% !important;
			transform: translate(-26%,-50%) !important;
		}
		.infor {
			position: relative;
			width:10rem;
			height: calc(10rem * (1051/1345));
			background: url(../assets/images/box2.png);
			background-size: 100% 100%;
			box-sizing: border-box;
			padding: 0.9rem .5rem;

			.close {
				position: absolute;
				    top: 1.3rem;
				    right: 1rem;
				    width: 1.3rem;
				    opacity: 1;
					cursor: pointer;

			}

			.tips {
				color: #8c8c8c;
				font-size: .2rem;
				text-align: center;
				width: 6rem;
				margin: 0.2rem auto;
				text-align: left;

			}
            .userinfo{
					width: 5rem;
					float: left;
					
					.head {
						width: 2rem;
						height: 2rem;
						background: url(../assets/images/head.png);
						background-size: 100% 100%;
						box-sizing: border-box;
						padding: 0.3rem;
						position: relative;
						margin: 0 auto;

						img {
							border-radius: 50%;
							overflow: hidden;
							width: 100%;
							height: 100%;
						}
					}

					.name {
						position: relative;
						margin: .2rem auto 0;
						text-align: center;
						width: 5rem;
						color: #13bcd1;
						font-size: .3rem;
						font-weight: bold;
						letter-spacing: 0.05rem;
					}

					.zw {
						position: relative;
						margin: 0 auto;
						text-align: center;
						width: 5rem;
						color: #13bcd1;
						font-size: .25rem;
					}

					.brif {
						position: relative;
						margin: 0.1rem 0.1rem 0;
						text-align: left;
						width: 5rem;
						color: #fff;
						font-size: .18rem;
						max-height: 2.2rem;
						overflow: scroll;
					}

					.brif::-webkit-scrollbar-track-piece {
						background-color: rgba(0, 0, 0, 0);
						border-left: .1rem solid rgba(0, 0, 0, 0);
					}

					.brif::-webkit-scrollbar {
						width: .15rem;
						height: .0rem;
						-webkit-border-radius: .05rem;
						-moz-border-radius: .05rem;
						border-radius: .05rem;
					}

					.brif::-webkit-scrollbar-thumb {
						background-color: rgba(0, 0, 0, 0.5);
						background-clip: padding-box;
						-webkit-border-radius: .05rem;
						-moz-border-radius: .05rem;
						border-radius: .05rem;
						min-height: .1rem;
						;
					}

					.brif::-webkit-scrollbar-thumb:hover {
						background-color: rgba(0, 0, 0, 0.5);
						-webkit-border-radius: .05rem;
						-moz-border-radius: .05rem;
						border-radius: .05rem;
					}
			}
			.userform{
					width: 4rem;
					    /* float: right; */
					    height: 50%;
					    position: absolute;
					    right: 0.3rem;
					    bottom: 0.6rem;
					
					.tel {
						position: relative;
						margin: .2rem auto;
						width: 3.8rem;
						height: 0.5rem;
						float: left;
					}
					
					.opinion {
						position: relative;
						margin: .2rem auto;
						width: 3.8rem;
						height: 1.5rem;
						float: left;
					}
					
					.submit {
						position: relative;
						margin: 0.1rem auto 0 0.95rem;
						width: 2rem;
						background: url(../assets/images/btn.png);
						background-size: 100% 100%;
						height: 0.45rem;
						float: left;
					}
					
					input,
					textarea {
						width: 100%;
						height: 100%;
						border-radius: 0.15rem;
						// background: none;
						border: none;
						text-indent: .2rem;
						font-size: 0.14rem;
					}
			}
			
		}
	}

	.videoBox {
		.bg {
			position: relative;
			width: 7.28rem;
			height: 12rem;
			background: url(../assets/images/box.png);
			background-size: 100% 100%;
			box-sizing: border-box;
			padding: 1rem .5rem;
			overflow: hidden;

			.contet {
				width: 100%;
				height: 100%;
				overflow: scroll;
			}

			.close {
				position: absolute;
				top: 0.7rem;
				right: 1rem;
				width: 0.82rem;
				opacity: 1;
			}

			.videoList {
				position: relative;
				width: 5.8rem;
				margin: 0 auto .5rem;
				border-block-end: #0c8eb1 dashed .05rem;
				box-sizing: border-box;
				padding: .1rem 0;

				video {
					position: relative;
					width: 5.8rem !important;
					// margin: 1.45rem auto 0;
				}

				.title {
					position: relative;
					margin: 0 auto;
					width: 5.8rem;
					color: #fff;
					font-size: .24rem;
					text-align: center;
				}
			}

			.start-play {
				cursor: pointer;
				width: 1.5rem;
				height: 1.5rem;
				background: linear-gradient(135deg, #909193 0%, #282828 100%);
				;
				opacity: 1;
				border-radius: 50%;
				display: block;
				position: absolute;
				margin: auto;
				top: 1.1rem;
				left: 50%;
				transform: translate(-50%, 0);

				&::after {
					content: "";
					width: 0;
					height: 0;
					border: 0.26rem solid transparent;
					border-left: 0.38rem solid white;
					position: absolute;
					top: 32%;
					left: 40%;
				}
			}

		}
	}

	.logo {
		position: relative;
		margin: .55rem auto 0;
		width: 12rem;

		.title {
			position: relative;
			margin: 0 auto;
			width: 12rem;
			height: calc(12rem * (158/1400));
			background: url(../assets/images/logo2.png);
			background-size: 100% 100%;
		}

		ul {
			display: flex;
			// justify-content: flex-start;
			width: 12rem;
			margin: 0.2rem auto;
			flex-wrap: wrap;
			justify-content: center;

			li {
				width: 3rem;
				margin: 0.25rem .1rem;
				display: flex;
				// justify-content: flex-start;
				align-items: center;

				.head {
					width: 1.2rem;
					height: 1.2rem;
					margin-right: .1rem;
					// background: url(../assets/images/head.png);
					background-size: 100% 100%;
					box-sizing: border-box;
					overflow: hidden;

					// border-radius:.2rem;
					// padding:  0.15rem;
					img {
						// border-radius: 50%;
						overflow: hidden;
						width: 100%;
						/* height: 100%; */

					}
				}

				.name {
					position: relative;
					text-align: left;
					// width: 1.25rem;
					color: #fff;
					font-size: .24rem;

					// margin: 0.15rem 0 0 0;
					.text {
						font-size: .18rem;
						color: #b5aeae;
					}
				}

			}
		}
	}
</style>
